"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../theme");
exports.Radio = react_1.default.memo(function (props) {
    return (react_1.default.createElement(Area, null,
        react_1.default.createElement(Label, null,
            react_1.default.createElement("input", __assign({}, props, { type: "radio", style: { accentColor: theme_1.theme.colors.red1 } })))));
});
var Area = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  align-items: center;\n"], ["\n  display: inline-block;\n  align-items: center;\n"])));
var Label = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 16px;\n  height: 16px;\n  input {\n    accent-color: red;\n  }\n"], ["\n  position: relative;\n  width: 16px;\n  height: 16px;\n  input {\n    accent-color: red;\n  }\n"])));
var templateObject_1, templateObject_2;
